import { render, staticRenderFns } from "./ProductRequestsDetail.vue?vue&type=template&id=14ed07a8&scoped=true&"
import script from "./ProductRequestsDetail.vue?vue&type=script&lang=js&"
export * from "./ProductRequestsDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14ed07a8",
  null
  
)

export default component.exports